<ion-app>
  <!-- Skip to main content link (WCAG 2.4.1 Bypass Blocks) -->
  <a href="#main-content" class="skip-link" (click)="focusMainContent($event)"
    >Skip to main content</a
  >

  <!-- Mobile Ion-Menu -->
  <ion-menu class="mobile-menu" contentId="main-content" [swipeGesture]="false">
    <ion-content class="ion-padding">
      <div>
        <ion-accordion-group>
          <ion-accordion class="mobile-menu__accordion">
            <ion-item slot="header">
              <ion-label>Adopt</ion-label>
            </ion-item>
            <div slot="content">
              <ion-menu-toggle>
                <a
                  [routerLink]="['/find-pet']"
                  [queryParams]="
                    buildFindPetQueryParams({ adoptOrFoster: 'ADOPT' })
                  "
                  queryParamsHandling="merge"
                  >All Pets for Adoption</a
                >
              </ion-menu-toggle>
              <ion-menu-toggle>
                <a
                  [routerLink]="['/find-pet']"
                  [queryParams]="
                    buildFindPetQueryParams({
                      species: 'Dog',
                      adoptOrFoster: 'ADOPT',
                    })
                  "
                  queryParamsHandling="merge"
                  >Dogs for Adoption</a
                >
              </ion-menu-toggle>
              <ion-menu-toggle>
                <a
                  [routerLink]="['/find-pet']"
                  [queryParams]="
                    buildFindPetQueryParams({
                      species: 'Cat',
                      adoptOrFoster: 'ADOPT',
                    })
                  "
                  queryParamsHandling="merge"
                  >Cats for Adoption</a
                >
              </ion-menu-toggle>
            </div>
          </ion-accordion>
          <ion-accordion class="mobile-menu__accordion">
            <ion-item slot="header">
              <ion-label>Foster</ion-label>
            </ion-item>
            <div slot="content">
              <ion-menu-toggle>
                <a
                  [routerLink]="['/find-pet']"
                  [queryParams]="
                    buildFindPetQueryParams({ adoptOrFoster: 'FOSTER' })
                  "
                  queryParamsHandling="merge"
                  >All Pets for Foster</a
                >
              </ion-menu-toggle>
              <ion-menu-toggle>
                <a
                  [routerLink]="['/find-pet']"
                  [queryParams]="
                    buildFindPetQueryParams({
                      species: 'Dog',
                      adoptOrFoster: 'FOSTER',
                    })
                  "
                  queryParamsHandling="merge"
                  >Dogs for Foster</a
                >
              </ion-menu-toggle>
              <ion-menu-toggle>
                <a
                  [routerLink]="['/find-pet']"
                  [queryParams]="
                    buildFindPetQueryParams({
                      species: 'Cat',
                      adoptOrFoster: 'FOSTER',
                    })
                  "
                  queryParamsHandling="merge"
                  >Cats for Foster</a
                >
              </ion-menu-toggle>
            </div>
          </ion-accordion>
          <ion-accordion class="mobile-menu__accordion">
            <ion-item slot="header">
              <ion-label>Post a Pet</ion-label>
            </ion-item>
            <div slot="content">
              <ion-menu-toggle>
                <a [routerLink]="['/account/my-pets/add']">Create a Posting</a>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <a [routerLink]="['/rehome']">About Rehoming</a>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <a [routerLink]="['/fostering']"
                  >Fostering Through Home To Home</a
                >
              </ion-menu-toggle>
            </div>
          </ion-accordion>
          <ion-accordion
            class="mobile-menu__accordion mobile-menu__accordion--primary"
          >
            <ion-item slot="header">
              <ion-label>{{
                isShelterPage ? "Home To Home" : "About Us"
              }}</ion-label>
            </ion-item>
            <div slot="content">
              <ion-menu-toggle>
                <a [routerLink]="['/about']">About</a>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <a [routerLink]="['/faq']">Helpful Tips/FAQ</a>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <a [routerLink]="['/blog']">Blog</a>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <a [routerLink]="['/story']">Adoption Success Stories</a>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <a [routerLink]="['/how-it-works']">How It Works</a>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <a [routerLink]="['/resources']">Resources</a>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <a [routerLink]="['/sponsors']">Sponsors</a>
              </ion-menu-toggle>
            </div>
          </ion-accordion>
          <!-- Super Admin Accordion -->
          <ion-accordion
            class="mobile-menu__accordion"
            *ngIf="authService.isSuperAdmin"
          >
            <ion-item slot="header">
              <ion-label>Super Admin</ion-label>
            </ion-item>
            <div slot="content">
              <ion-menu-toggle>
                <a [routerLink]="['/superadmin/support']">Support</a>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <a [routerLink]="['/superadmin/social-media']">Social Media</a>
                <a [routerLink]="['/superadmin/spam-reports']">Spam</a>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <a [routerLink]="['/superadmin/reports']">Reports</a>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <a [routerLink]="['/superadmin/finances']">Finances</a>
              </ion-menu-toggle>
              <ion-menu-toggle>
                <a [routerLink]="['/superadmin/sms-logs']">SMS Logs</a>
              </ion-menu-toggle>
            </div>
          </ion-accordion>
        </ion-accordion-group>
        <div>
          <div class="mobile-menu__item" [ngClass]="{ shelter: isShelterPage }">
            <div class="mobile-menu__item__button">
              <ion-menu-toggle>
                <a
                  *ngIf="
                    (authService.isShelterAdmin && !authService.isSuperAdmin) ||
                    shelterUuid
                  "
                  [routerLink]="['/contact']"
                  [queryParams]="
                    shelterUuid ? { shelterUuid: shelterUuid } : {}
                  "
                  >Contact</a
                >
              </ion-menu-toggle>
            </div>
          </div>
          <div class="mobile-menu__item">
            <div class="mobile-menu__item__button">
              <a *ngIf="!isShelterPage" [routerLink]="['/join-as-shelter']"
                >For Shelters</a
              >
            </div>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-menu>
  <!-- Router Outlets -->
  <ion-router-outlet name="modal"></ion-router-outlet>
  <ion-router-outlet
    id="main-content"
    role="main"
    aria-label="Main content"
    tabindex="-1"
  ></ion-router-outlet>

  <!-- Expired Pets Modal -->
  <app-expired-pets-modal
    [isOpen]="isExpiredPetsModalOpen"
    [expiredPets]="expiredPets"
    (modalClosed)="onExpiredPetsModalClosed()"
  ></app-expired-pets-modal>

  <!-- Cookie Consent Popup -->
  <app-cookie-consent-popup></app-cookie-consent-popup>
</ion-app>
